
export default {
    fyiTabState: 0,
    totalPendingNum: 0,
    fyi: {
        fyiDeliveryOptions: [],
        fyiDisclaimers: [],
        fyiSettings: [],
        fyiNotifications: undefined,
        fyiAlerts: undefined
    },
    countryCodes: [],
    feedbackData: [],
    fyiUnreadNum: 0,
    unsavedPriceAlerts: undefined
}
